import React, { useCallback, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import microsoftTeamsIcon from '~/assets/public/microsoft-teams.svg';
import { BackLink, Page } from '~/components';
import { useApi, useIntegrations, useWorkspace } from '~/contexts';
import { useDocumentTitle } from '~/hooks';
import MicrosoftSettingsPage from './MicrosoftSettingsPage';

const MicrosoftLogo = styled.img`
  width: 2.875rem;
  height: 2.875rem;
  max-width: unset;
`;

export default function MicrosoftSettingsArea() {
  useDocumentTitle('Microsoft 365 Settings');

  const { workspace } = useWorkspace();
  const { microsoft } = useIntegrations();
  const api = useApi();
  const [integration, setIntegration] = useState(null);

  const fetchIntegration = useCallback(async () => {
    const { data } = await api.www.workspaces(workspace.id).integrations().microsoft.teams.get();
    setIntegration(data);
  }, [api, workspace.id]);

  useEffect(() => {
    fetchIntegration();
  }, [fetchIntegration]);

  const integrationsUrl = `/app/${workspace.key}/settings/integrations`;

  if (microsoft === undefined) return null;
  if (!microsoft || integration?.isConnected === false) return <Redirect to={integrationsUrl} />;

  return (
    <Page>
      <Page.Header>
        <BackLink defaultPath={integrationsUrl} ignoreHistory />

        <Page.Info>
          <Page.Eyebrow>Settings</Page.Eyebrow>
          <Page.Title data-testid="ms-organization-name">
            {integration?.connection.tenantDomain ?? 'Microsoft 365'}
          </Page.Title>
        </Page.Info>

        <Page.Actions>
          <MicrosoftLogo src={microsoftTeamsIcon} />
        </Page.Actions>
      </Page.Header>

      <MicrosoftSettingsPage />
    </Page>
  );
}
